/**
 * Presence ball for Administração Usuários and Entidades.
 * Green = live SignalR (Carteira hub ping).
 * Red = has Conta Digital / can log into Carteira, currently offline.
 * Orange = Sem conta, Aguardando primeiro acesso, or console-only (no Carteira account).
 *
 * @param {{ loggedIn?: boolean, hasAccount?: boolean|null, accessStatus?: string|null }} flags
 * @returns {"online"|"offline"|"none"}
 */
export const resolveBaasPresenceDot = ({
  loggedIn = false,
  hasAccount,
  accessStatus,
} = {}) => {
  const awaitingFirstAccess = String(accessStatus ?? "").trim().toLowerCase() === "pending";
  const noAccount = hasAccount === false;
  if (noAccount || awaitingFirstAccess) return "none";
  if (loggedIn) return "online";
  return "offline";
};
